module.exports = __webpack_public_path__ + "static/media/search-no-info.c6f7b0b5.svg";